import styled from "styled-components";

export const BarraBotoes = styled.div`
    display: flex;
    flex: 0 0 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.8);
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    z-index: 1000;
    color: white;

    .ant-select-selection-item{
        color: white !important;
    }
    
    span{
      font-size: 14px;
      font-weight: 500;
    }
    .buttons-container{
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .relatorioPowerBiPagesSelect{
        width: 250;
        color: white
    }
    .toggle-fullscreen{
        background: transparent;
        color: white;
        width: 28px;
        height: 28px;
        padding: 0px
    }
`;